import { render } from "./BuyCarComponent.vue?vue&type=template&id=cc480ea4&ts=true"
import script from "./BuyCarComponent?vue&type=script&lang=ts"
export * from "./BuyCarComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__